import Vue from "vue";
import Router from "vue-router";
import store from "./store";

const NewUser = () => import("./views/NewUser");
const NewSrc = () => import("./views/NewSrc");
const SchoolsList = () => import("./views/SchoolsList");
const PrimarySchoolsList = () => import("./views/PrimarySchoolsList");
const GroupsList = () => import("./views/GroupsList");
const HeadlineData = () => import("./views/HeadlineData");
const TrainersList = () => import("./views/TrainersList");
const CoordinatorsList = () => import("./views/CoordinatorsList");
const NewCoordinator = () => import("./views/NewCoordinator");
const EditCoordinator = () => import("./views/EditCoordinator");
const NewTrainer = () => import("./views/NewTrainer");
const EditGroup = () => import("./views/EditGroup");
const EditTeam = () => import("./views/EditTeam");
const TeamsList = () => import("./views/TeamsList");
const EditTrainer = () => import("./views/EditTrainer");
const NewSchool = () => import("./views/NewSchool");
const EditSchool = () => import("./views/EditSchool");
const EditPrimarySchool = () => import("./views/EditPrimarySchool");
const NewPrimarySchool = () => import("./views/NewPrimarySchool");
const TeacherList = () => import("./views/TeacherList");
const NewTeacher = () => import("./views/NewTeacher");
const EditTeacher = () => import("./views/EditTeacher");
const DataGroup = () => import("./views/DataGroup");
const DataTrainer = () => import("./views/DataTrainer");
const DataSchool = () => import("./views/DataSchool");
const DataTeacher = () => import("./views/DataTeacher");
const DataStudent = () => import("./views/DataStudent");
const Home = () => import("./views/Home");
const EditStudent = () => import("./views/EditStudent");
const NewStudent = () => import("./views/NewStudent");
const StudentsList = () => import("./views/StudentsList");
const EditOptions = () => import("./views/EditOptions");
const MioAnnualInteractions = () => import("./views/MioAnnualInteractions");
const MioClassVisits = () => import("./views/MioClassVisits");
const MioParentCertificates = () => import("./views/MioParentCertificates");
const MioTrainerTeams = () => import("./views/MioTrainerTeams");
const MioLocationPerformance = () => import("./views/MioLocationPerformance");
const MioSchoolsMap = () => import("./views/MioSchoolsMap");
const MioTrainerCoordinatorPerformance = () =>
  import("./views/MioTrainerCoordinatorPerformance");
const MioRemunerationReconciliation = () =>
  import("./views/MioRemunerationReconciliation");
const MioClassroomAttainment = () => import("./views/MioClassroomAttainment");
const MioCovidObservations = () => import("./views/MioCovidObservations");
const MioConsent = () => import("./views/MioConsent");
const RcTrainerActivity = () => import("./views/RcTrainerActivity");
const RcSummary = () => import("./views/RcSummary");
const RcPerformance = () => import("./views/RcPerformance");
const CeoBonuses = () => import("./views/CeoBonuses");
const CountryActivity = () => import("./views/CountryActivity");
const RcBonusCalculation = () => import("./views/RcBonusCalculation");
const SrcList = () => import("./views/SrcList");
const EditSrc = () => import("./views/EditSrc");
const SchoolLocation = () => import("./views/SchoolLocation");
const EditClass = () => import("./views/EditClass");
const ClassList = () => import("./views/ClassList");
const UserProfile = () => import("./views/UserProfile");
const NotFound = () => import("./views/NotFound");

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  },
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/edit-options",
      name: "EditOptions",
      component: EditOptions,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/data/headline-data",
      name: "HeadlineData",
      component: HeadlineData,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/data/groups",
      name: "DataGroup",
      component: DataGroup,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/data/trainers",
      name: "DataTrainer",
      component: DataTrainer,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/data/schools",
      name: "DataSchool",
      component: DataSchool,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/data/teachers",
      name: "DataTeacher",
      component: DataTeacher,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/data/students",
      name: "DataStudent",
      component: DataStudent,
      meta: {
        requiresAuth: false,
        admin: false,
      },
    },
    {
      path: "/users/add",
      name: "NewUser",
      component: NewUser,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/src/add",
      name: "NewSrc",
      component: NewSrc,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/teams/add",
      name: "NewTeam",
      component: EditTeam,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/teams/:id",
      name: "EditTeam",
      component: EditTeam,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/teams",
      name: "TeamsList",
      component: TeamsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/groups",
      name: "GroupsList",
      component: GroupsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/groups/add",
      name: "NewGroup",
      component: EditGroup,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/groups/:id",
      name: "EditGroup",
      component: EditGroup,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/schools",
      name: "SchoolsList",
      component: SchoolsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/schools/add",
      name: "NewSchool",
      component: NewSchool,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/schools/:id",
      name: "EditSchool",
      component: EditSchool,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/coordinators",
      name: "CoordinatorsList",
      component: CoordinatorsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/coordinators/:id",
      name: "EditCoordinator",
      component: EditCoordinator,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/coordinators/add",
      name: "NewCoordinator",
      component: NewCoordinator,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/trainers",
      name: "TrainersList",
      component: TrainersList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/trainers/add",
      name: "NewTrainer",
      component: NewTrainer,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/trainers/:id",
      name: "EditTrainer",
      component: EditTrainer,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/teachers",
      name: "TeacherList",
      component: TeacherList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/teachers/add",
      name: "NewTeacher",
      component: NewTeacher,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/teachers/:id",
      name: "EditTeacher",
      component: EditTeacher,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/students",
      name: "StudentsList",
      component: StudentsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/students/add",
      name: "NewStudent",
      component: NewStudent,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/students/:id",
      name: "EditStudent",
      component: EditStudent,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/primary-schools",
      name: "PrimarySchoolsList",
      component: PrimarySchoolsList,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/primary-schools/add",
      name: "NewPrimarySchool",
      component: NewPrimarySchool,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/primary-schools/:id",
      name: "EditPrimarySchool",
      component: EditPrimarySchool,
      meta: {
        requiresAuth: true,
        admin: false,
      },
    },
    {
      path: "/mio/annual-interactions",
      name: "MioAnnualInteractions",
      component: MioAnnualInteractions,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/class-visits",
      name: "MioClassVisits",
      component: MioClassVisits,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/parent-certificates",
      name: "MioParentCertificates",
      component: MioParentCertificates,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/trainer-teams",
      name: "MioTrainerTeams",
      component: MioTrainerTeams,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/location-performance",
      name: "MioLocationPerformance",
      component: MioLocationPerformance,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/schools-map",
      name: "MioSchoolsMap",
      component: MioSchoolsMap,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/trainer-coordinator-performance",
      name: "MioTrainerCoordinatorPerformance",
      component: MioTrainerCoordinatorPerformance,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/remuneration-reconciliation",
      name: "MioRemunerationReconciliation",
      component: MioRemunerationReconciliation,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/classroom-attainment",
      name: "MioClassroomAttainment",
      component: MioClassroomAttainment,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/covid-observations",
      name: "MioCovidObservations",
      component: MioCovidObservations,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/mio/consent",
      name: "MioConsent",
      component: MioConsent,
      meta: {
        requiresAuth: true,
        admin: true,
      },
    },
    {
      path: "/rc/trainer-activity",
      name: "TrainerActivity",
      component: RcTrainerActivity,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/rc/summary",
      name: "RcSummary",
      component: RcSummary,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/cd/country-activity",
      name: "CdCountryActivity",
      component: CountryActivity,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/src/country-activity",
      name: "SrcCountryActivity",
      component: CountryActivity,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/pd/rc-performance",
      name: "RcPerformance",
      component: RcPerformance,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/pd/ceo-bonuses",
      name: "CeoBonuses",
      component: CeoBonuses,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/rc/bonus-calculation",
      name: "RcBonusCalculation",
      component: RcBonusCalculation,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/src/bonus-calculation",
      name: "SrcBonusCalculation",
      component: RcBonusCalculation,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/user/list/src",
      name: "SrcList",
      component: SrcList,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/users/admin",
      name: "AdminList",
      component: SrcList,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/src/:id",
      name: "EditSrc",
      component: EditSrc,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: "/school-location",
      name: "SchoolLocation",
      component: SchoolLocation,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/class/add",
      name: "AddClass",
      component: EditClass,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/class/:id",
      name: "EditClass",
      component: EditClass,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/class",
      name: "ClassList",
      component: ClassList,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "/user/:id/:type",
      name: "UserProfile",
      component: UserProfile,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: "*",
      component: NotFound,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const publicPages = [
    "/",
    "/data/headline-data",
    "/data/trainers",
    "/data/schools",
    "/data/teachers",
    "/data/students",
  ];
  const adminPages = [
    "/edit-options",
    "/users/add",
    "/teams/add",
    "/groups/add",
    "/coordinators",
    "/coordinators/add",
    "/trainers",
    "/trainers/add",
    "/schools/add",
    "/primary-schools/add",
    "/teachers/add",
    "/students/add",
    "/mio/annual-interactions",
    "/mio/class-visits",
    "/mio/parent-certificates",
    "/mio/trainer-teams",
    "/mio/location-performance",
    "/mio/schools-map",
    "/mio/trainer-coordinator-performance",
    "/mio/remuneration-reconciliation",
    "/mio/classroom-attainment",
    "/mio/covid-observations",
    "/mio/consent",
    "/cd/country-activity",
    "/src/country-activity",
    "/src",
    "/pd/rc-performance",
    "/pd/ceo-bonuses",
  ];

  const authRequired = !publicPages.includes(to.path);
  const adminRequired = adminPages.includes(to.path);

  if ((authRequired || adminRequired) && !store.getters["auth/isLoggedIn"]) {
    store.dispatch("auth/REQUIRES_AUTH");
    return next("/");
  }

  if (adminRequired && !store.getters["auth/isAdmin"] && !store.getters["auth/isSRC"]) {
    store.dispatch("auth/REQUIRES_ADMIN");
    return next("/");
  }

  next();
});

export default router;
